import 'bulma/css/bulma.min.css';
import 'bulma-extensions//dist/css/bulma-extensions.min.css'
import React, { useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {IconLookup, IconDefinition, findIconDefinition, IconPrefix, IconName} from '@fortawesome/fontawesome-svg-core'
import StaffNotification from '../dataObjects/StaffNotification'

const SnoozeTypes = {
    OneHour: "OneHour",
    FourHour: "FourHour",
    Tomorrow: "Tomorrow",
    NextWeek: "NextWeek",
    Custom: "Custom"
}

interface Props {
    item: StaffNotification;
    index: number;
    groupId: string;
    removeItem: any;
    archiveItem: any;
    processTimesheetRequest: any;
    snoozeItem: any;
    addItemNote: any;
}

function NotificationCard(props: any) {

    const cardStyle = {
        div: {
            marginBottom: "10px"
        },

        timeDisplay: {
            textDecoration: "none",
            borderRight: "none",
            justifyContent: "left",
            marginLeft: "10px"
        },

        actionDiplay: {
            justifyContent: "right"
        },

        iconDiplay: {
            marginRight: "10px"
        },

        noteCheckIconDisplay: {
            marginTop: "1px"
        }
    };


    const TODAY = getFormattedDate(new Date());

    const [isSnoozeListActive, setSnoozeListStatus] = useState('');
    const [isNoteDivActive, setNoteDivStatus] = useState('');
    const [itemNote, setItemNote] = useState(props.item.note);
    const [showMore, setShowMore] = useState(false);

    function removeItem(index: number, groupId: string, item: StaffNotification) { 
        props.removeItem(index, groupId, item);
    }

    function archiveItem(item: StaffNotification) {
        props.archiveItem(item);
    }

    function autoArchive(item: StaffNotification) {

        //phone log
        if (item.applicationId == 3) {
            return;
        }

        if (item.body.indexOf('here</a>') > 0 || item.body.indexOf('Discuss</a>') > 0) {
            props.archiveItem(item);
        }
    }

    function processTimesheetRequest(item: StaffNotification, event?: any) {
        let requestId = event.target.dataset.requestId;
        let action = event.target.dataset.action;
        props.processTimesheetRequest(item, requestId, action);
    }

    function snoozeItem(index: number, groupId: string, snoozeType: string, item: StaffNotification, event?: any) {
        let snoozeDate = '';
        if (snoozeType == SnoozeTypes.Custom) {
            snoozeDate = event.target.value;
        }
        props.snoozeItem(index, groupId, snoozeType, item, snoozeDate);
        toggleSnoozeList();
    }

    function updateItemNote(event: any) {
        setItemNote(event.target.value);
    }

    function getNotificationIconType(iconString: string) {
        let iconGroup = iconString.substr(0, 3);
        let iconType = iconString.substr(7);
        const iconLookup: IconLookup = { prefix: iconGroup as IconPrefix, iconName: iconType as IconName }
        const applicationIconDefinition: IconDefinition = findIconDefinition(iconLookup)
        return applicationIconDefinition;
    }

    function addItemNote(id: number, groupId: string) {
        if (itemNote.trim() != '') {
            props.addItemNote(id, groupId, itemNote);
            setItemNote('');
            toggleNoteDiv();
        }
    }

    function toggleSnoozeList() {
        if (isSnoozeListActive == '') {
            setSnoozeListStatus('is-active');;
        }
        else {
            setSnoozeListStatus('');
        }

        if (isNoteDivActive == 'is-active') {
            setNoteDivStatus('');;
        }
    }

    function toggleNoteDiv() {
        if (isNoteDivActive == '') {
            setNoteDivStatus('is-active');;
        }
        else {
            setNoteDivStatus('');
        }

        if (isSnoozeListActive == 'is-active') {
            setSnoozeListStatus('');
        }
    }

    function displayNotificationContent() {
        let shortBody = props.item.body.substring(0, 250) + '... ';

        //timesheets
        if (props.item.applicationId== 1) {
            return (//need to pass event
                <span onClick={(event) => processTimesheetRequest(props.item, event)} dangerouslySetInnerHTML={{ __html: props.item.body }} ></span>
            )
        }

        if (props.item.body.length <= 350) {
            return (
                <span onClick={() => autoArchive(props.item)} dangerouslySetInnerHTML={{ __html: props.item.body }} ></span>
            )
        }
        else {
            if (showMore) {
                return (
                    <>
                        <span onClick={() => autoArchive(props.item)} dangerouslySetInnerHTML={{ __html: props.item.body }} ></span>
                        {' '}
                        <a className="is-size-7 has-text-link is-italic has-text-weight-bold" onClick={() => setShowMore(!showMore)} onMouseOver={() => setShowMore(!showMore)}>Show less</a>
                    </>
                )
            }
            else {
                return (
                    <>
                        <span onClick={() => autoArchive(props.item)} dangerouslySetInnerHTML={{ __html: shortBody }} ></span>
                        <a className="is-size-7 has-text-link is-italic has-text-weight-bold" onClick={() => setShowMore(!showMore)} onMouseOver={() => setShowMore(!showMore)}>Show more</a>
                    </>
                )
            }
        }
    }

    function getFormattedDate(date: Date) {
        var currentDate = new Date(date);
        var dd = currentDate.getDate() + "";
        if (dd.length == 1) {
            dd = "0" + dd;
        }

        var mm = (currentDate.getMonth() + 1) + ""; //January is 0!
        if (mm.length == 1) {
            mm = "0" + mm;
        }

        var yyyy = currentDate.getFullYear();

        return (yyyy + '-' + mm + '-' + dd); //need this format to get the input date field work!
    }

    return (
        <div id={`notification-${props.item.id}`} className="card" style={cardStyle.div}>
            <header className="card-header">
                <p className="card-header-title">
                    <span style={cardStyle.iconDiplay}><FontAwesomeIcon title="High Priority" icon={getNotificationIconType(props.item.iconClass)} /></span>
                    <span dangerouslySetInnerHTML={{ __html: props.item.title }}></span>
                </p>
                {props.item.isHighPriority>0 &&
                    <p className="card-header-icon">
                        <span className="icon">
                        <span className="has-text-danger"><FontAwesomeIcon title="High Priority" icon={["fas", "circle-exclamation"]} /></span>
                    </span>
                    </p>
                }
            </header>
            <div className="card-content">
                <div className="content">
                    {displayNotificationContent()}
                 </div>
            </div>
            <footer className="card-footer">
                <span className="card-footer-item is-italic has-text-info is-size-7 has-text-weight-bold" style={cardStyle.timeDisplay}>{props.item.notificationDateTime}</span>
                <span className="card-footer-item" style={cardStyle.actionDiplay} >
                    <div className={`dropdown is-right is-up ${isNoteDivActive}`}>
                        <div className="dropdown-trigger">
                            {props.item.note
                                ? <span className="tooltip is-tooltip-top is-tooltip-info has-text-success is-clickable" data-tooltip={props.item.note}><FontAwesomeIcon onClick={toggleNoteDiv} style={cardStyle.iconDiplay} icon={["far", "comment-alt"]} aria-haspopup="true" aria-controls="dropdown-menu" /></span>
                                : <FontAwesomeIcon className="is-clickable" title="Add Note" onClick={toggleNoteDiv} style={cardStyle.iconDiplay} icon={["far", "sticky-note"]} aria-haspopup="true" aria-controls="dropdown-menu" />
                            }
                        </div>
                        <div className="dropdown-menu" id="dropdown-menu" role="menu">
                            <div className="dropdown-content">
                                <div className="dropdown-item">
                                    <p className="control has-icons-right">
                                        <input className="input" value={itemNote} type="text" onChange={updateItemNote} placeholder="Add note..." />
                                        <span className="icon is-right has-text-success is-clickable" style={cardStyle.noteCheckIconDisplay}>
                                            <FontAwesomeIcon onClick={() => addItemNote(props.item.id, props.groupId)} icon={["fas", "check"]} />
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`dropdown is-right is-up ${isSnoozeListActive}`}>
                        <div className="dropdown-trigger">
                            {props.item.snoozeDateTime
                                ? <span className="has-text-success tooltip is-tooltip-top is-tooltip-info is-clickable" data-tooltip={`Snooze until ${props.item.snoozeDateTime}`}><FontAwesomeIcon onClick={toggleSnoozeList} style={cardStyle.iconDiplay} icon={["far", "bell"]} aria-haspopup="true" aria-controls="dropdown-menu1" /></span>
                                : <span className="is-clickable"><FontAwesomeIcon title="Snooze until..." onClick={toggleSnoozeList} style={cardStyle.iconDiplay} icon={["far", "clock"]} aria-haspopup="true" aria-controls="dropdown-menu1" /></span>
                            }
                        </div>
                        <div className="dropdown-menu snooze-dropdown-menu" id="dropdown-menu1" role="menu">
                            <div className="dropdown-content">
                                <span className="dropdown-item has-text-info">Snooze...</span>
                                <a className="dropdown-item">
                                    <span onClick={() => snoozeItem(props.index, props.groupId, SnoozeTypes.OneHour, props.item)}>in 1 hour</span>
                                </a>
                                <a className="dropdown-item">
                                    <span onClick={() => snoozeItem(props.index, props.groupId, SnoozeTypes.FourHour, props.item)}>in 4 hours</span>
                                </a>
                                <a className="dropdown-item">
                                    <span onClick={() => snoozeItem(props.index, props.groupId, SnoozeTypes.Tomorrow, props.item)}>Tomorrow</span>
                                </a>
                                <a className="dropdown-item">
                                    <span onClick={() => snoozeItem(props.index, props.groupId, SnoozeTypes.NextWeek, props.item)}>Next week</span>
                                </a>
                                <a className="dropdown-item">
                                    <span>
                                        <input onChange={(event) => { snoozeItem(props.index, props.groupId, SnoozeTypes.Custom, props.item, event) }} className="input input-date is-small cases-start-date" type="date" value={TODAY} />
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <span className='is-clickable'><FontAwesomeIcon title="Archive" onClick={() => archiveItem(props.item)} style={cardStyle.iconDiplay} icon={["fas", "box-archive"]} /></span>
                    <span className='is-clickable'><FontAwesomeIcon title="Delete" onClick={() => removeItem(props.index, props.groupId, props.item)} style={cardStyle.iconDiplay} icon={["fas", "trash-can"]} /></span>
                </span>
            </footer>
        </div>
    );
}

export default NotificationCard;